/**
 * Manifest of per-module register.ts loaders.
 *
 * The component registry (`src/components/shared/configurable/registry.ts`)
 * is populated lazily — only when a module's `register.ts` is imported.
 * In a fresh admin session no module routes have been visited yet, so the
 * registry is empty.
 *
 * The admin inventory page (`ComponentsListPage`) awaits every loader
 * below at mount time. Each loader is a dynamic `import()` so the admin
 * chunk does not pull in module code until an admin actually opens the
 * inventory.
 *
 * To add a new configurable module, add one entry here. Keep the key
 * matching the module's registration `module` field (e.g. `"claimflow"`)
 * for parity with `getComponentsByModule()`.
 *
 * - `claimflow`: its `register.ts` registers eagerly on import.
 * - `extranet`: its aggregator (`components/register.ts`, also exported as
 *   `registerExtranetComponents` from `@modules/extranet`) only registers
 *   when called, so the loader calls it — idempotent (`registerOnce`), so a
 *   registry already filled by the module routes is left untouched.
 */

export type ConfigurableModuleLoader = () => Promise<unknown>;

export const CONFIGURABLE_MODULE_LOADERS: Record<string, ConfigurableModuleLoader> = {
  claimflow: () => import('@modules/claimflow/components/register'),
  extranet: () =>
    import('@modules/extranet/components/register').then(({ registerExtranetComponents }) => {
      registerExtranetComponents();
    }),
};
